export default {"src":"/blogs/_next/static/media/karePediaFirstLogoDark.69238f50.gif","height":93,"width":145,"blurWidth":0,"blurHeight":0};